import { CheckingAccountListSchema, type CheckingAccount } from "@/types/CheckingAccount";
import type { Code } from "@/types/Codes";

export const getCheckingAccounts = async (userGroup: Code | null | undefined, activeOnly: boolean): Promise<CheckingAccount[]> => {
  let checkingAccounts: CheckingAccount[] = [];
  let ledgerString = "/ledger?active-only=" + activeOnly;
  if (userGroup != null) {
    ledgerString += "&user-group=" + userGroup.num;
  }

  await axios
    .get(ledgerString)
    .then((response) => {
      checkingAccounts = CheckingAccountListSchema.parse(response.data.result);
    })
    .catch((e) => errorApi(e));
  return checkingAccounts;
};
